import { render, staticRenderFns } from "./OCPILogsList.vue?vue&type=template&id=6ba74ed4&"
import script from "./OCPILogsList.vue?vue&type=script&lang=js&"
export * from "./OCPILogsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports